import React, { Component } from "react";
import 'bootstrap-icons/font/bootstrap-icons.css';

class ZoneaidHome extends Component {

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "ZoneAid — Smarter Recruiting";
  }

  renderStyles() {
    return (
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=Barlow:wght@400;500;600;700&display=swap');

        .zh-page {
          font-family: 'Barlow', system-ui, sans-serif;
          color: #1D2732;
          background: #fff;
          min-height: 100vh;
        }

        .zh-nav {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 20px 32px;
          max-width: 960px;
          margin: 0 auto;
        }
        .zh-logo {
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 700;
          font-size: 26px;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          color: #17293C;
        }
        .zh-logo span { color: #D5232E; }
        .zh-nav-cta {
          background: #17293C;
          color: #fff;
          font-weight: 600;
          font-size: 14px;
          padding: 9px 20px;
          border-radius: 8px;
          text-decoration: none;
          transition: background .12s ease;
        }
        .zh-nav-cta:hover { background: #0f1c28; color: #fff; }

        .zh-hero {
          background: #17293C;
          color: #fff;
          text-align: center;
          padding: 72px 24px 80px;
        }
        .zh-hero-inner { max-width: 680px; margin: 0 auto; }
        .zh-eyebrow {
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.16em;
          font-size: 13px;
          color: #90AFC4;
          margin-bottom: 16px;
        }
        .zh-hero h1 {
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 700;
          font-size: clamp(38px, 6vw, 58px);
          line-height: 1.0;
          text-transform: uppercase;
          letter-spacing: 0.01em;
          margin: 0 0 20px;
        }
        .zh-hero h1 span { color: #90AFC4; }
        .zh-hero p {
          font-size: 17px;
          line-height: 1.65;
          color: #C6D6E2;
          margin: 0 auto 36px;
          max-width: 520px;
        }
        .zh-hero-cta {
          display: inline-block;
          background: #D5232E;
          color: #fff;
          font-weight: 700;
          font-size: 16px;
          padding: 14px 36px;
          border-radius: 10px;
          text-decoration: none;
          box-shadow: 0 6px 20px rgba(213,35,46,.32);
          transition: background .12s ease, transform .12s ease;
        }
        .zh-hero-cta:hover { background: #B81C26; color: #fff; transform: translateY(-1px); }

        .zh-stats {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1px;
          background: #D8E3EB;
          border-top: 1px solid #D8E3EB;
          border-bottom: 1px solid #D8E3EB;
        }
        .zh-stat {
          background: #fff;
          text-align: center;
          padding: 32px 16px;
        }
        .zh-stat-num {
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 700;
          font-size: 42px;
          color: #17293C;
          line-height: 1;
          display: block;
        }
        .zh-stat-num span { color: #D5232E; }
        .zh-stat-label {
          font-size: 13px;
          color: #6B7D8D;
          margin-top: 6px;
          line-height: 1.4;
          display: block;
        }

        .zh-features {
          max-width: 960px;
          margin: 0 auto;
          padding: 64px 32px;
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 32px 48px;
        }
        .zh-feature { display: flex; gap: 18px; align-items: flex-start; }
        .zh-feature-icon {
          flex-shrink: 0;
          width: 48px; height: 48px;
          background: #EEF3F7;
          border-radius: 12px;
          display: flex; align-items: center; justify-content: center;
          font-size: 22px;
          color: #17293C;
        }
        .zh-feature h3 {
          font-size: 16px;
          font-weight: 700;
          margin: 0 0 5px;
          color: #17293C;
        }
        .zh-feature p {
          font-size: 14px;
          color: #55677A;
          margin: 0;
          line-height: 1.6;
        }

        .zh-band {
          background: #EEF3F7;
          padding: 56px 24px;
          text-align: center;
        }
        .zh-band-inner { max-width: 560px; margin: 0 auto; }
        .zh-band h2 {
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 700;
          font-size: 34px;
          text-transform: uppercase;
          letter-spacing: 0.01em;
          color: #17293C;
          margin: 0 0 12px;
        }
        .zh-band p {
          font-size: 15px;
          color: #55677A;
          margin: 0 0 28px;
          line-height: 1.6;
        }

        .zh-footer {
          text-align: center;
          padding: 24px;
          font-size: 12px;
          color: #9BAAB8;
          border-top: 1px solid #E3EAF0;
        }

        @media (max-width: 600px) {
          .zh-nav { padding: 16px 20px; }
          .zh-stats { grid-template-columns: 1fr; }
          .zh-features { grid-template-columns: 1fr; padding: 40px 20px; gap: 28px; }
          .zh-hero { padding: 52px 20px 60px; }
        }
      `}</style>
    );
  }

  render() {
    return (
      <div className="zh-page">
        {this.renderStyles()}

        <nav>
          <div className="zh-nav">
            <div className="zh-logo">Zone<span>Aid</span></div>
            <a href="mailto:support@renolition.com" className="zh-nav-cta">Get in touch</a>
          </div>
        </nav>

        <section className="zh-hero">
          <div className="zh-hero-inner">
            <div className="zh-eyebrow">Recruiting Intelligence</div>
            <h1>Find the right<br /><span>candidates</span><br />faster than ever</h1>
            <p>
              ZoneAid helps recruiting firms cut time-to-hire, surface qualified candidates
              automatically, and make smarter decisions — backed by data, not guesswork.
            </p>
            <a href="mailto:support@renolition.com" className="zh-hero-cta">
              <i className="bi bi-send me-2" />Request a demo
            </a>
          </div>
        </section>

        <div className="zh-stats">
          <div className="zh-stat">
            <span className="zh-stat-num">3<span>×</span></span>
            <span className="zh-stat-label">faster time-to-hire<br />vs. traditional methods</span>
          </div>
          <div className="zh-stat">
            <span className="zh-stat-num">80<span>%</span></span>
            <span className="zh-stat-label">reduction in<br />unqualified applicants</span>
          </div>
          <div className="zh-stat">
            <span className="zh-stat-num">24<span>h</span></span>
            <span className="zh-stat-label">average time to first<br />qualified candidate</span>
          </div>
        </div>

        <div className="zh-features">
          <div className="zh-feature">
            <div className="zh-feature-icon"><i className="bi bi-funnel-fill" /></div>
            <div>
              <h3>Smart Pre-Screening</h3>
              <p>Automated questionnaires filter out unqualified applicants before they reach your desk — only the right profiles get through.</p>
            </div>
          </div>
          <div className="zh-feature">
            <div className="zh-feature-icon"><i className="bi bi-graph-up-arrow" /></div>
            <div>
              <h3>Data-Driven Matching</h3>
              <p>Every answer is scored against your requirements in real time. No manual review of hundreds of CVs.</p>
            </div>
          </div>
          <div className="zh-feature">
            <div className="zh-feature-icon"><i className="bi bi-stopwatch" /></div>
            <div>
              <h3>Built for Speed</h3>
              <p>Launch a targeted candidate search in minutes. Candidates complete the process in under 60 seconds — no friction, no drop-off.</p>
            </div>
          </div>
          <div className="zh-feature">
            <div className="zh-feature-icon"><i className="bi bi-shield-check" /></div>
            <div>
              <h3>GDPR Compliant</h3>
              <p>Candidate data is handled transparently and in full compliance with EU data protection regulations. Built for the European market.</p>
            </div>
          </div>
        </div>

        <div className="zh-band">
          <div className="zh-band-inner">
            <h2>Ready to hire smarter?</h2>
            <p>Join recruiting firms across Europe that rely on ZoneAid to find qualified candidates — faster, cheaper, and with less noise.</p>
            <a href="mailto:support@renolition.com" className="zh-hero-cta">
              <i className="bi bi-envelope me-2" />Get in touch
            </a>
          </div>
        </div>

        <footer className="zh-footer">
          © {new Date().getFullYear()} ZoneAid. All rights reserved.
        </footer>
      </div>
    );
  }
}

export default ZoneaidHome;
